import styled from '@emotion/styled';
import * as React from 'react';

import goalIcon from 'src/public/img/archery-target.svg';

import { WithTranslation, withTranslation } from 'react-i18next';
import { ProgramEnum } from 'src/modules/programs/models/programs';
import { SurveyQuestionSwitch } from 'src/modules/programs/surveys/components/SurveyQuestionSwitch';
import {
    GenericSurveyAnswer,
    GenericSurveyQuestion,
} from 'src/modules/programs/surveys/models/surveys';
import { GenericProgramSurvey } from 'src/modules/programs/surveys/models/surveysGeneric';
import { hexToRgba } from 'src/shared/helpers/hexToRgba';
import { color, font } from 'src/shared/styles/variables';

const GoalImportanceWrapper = styled.div({
    margin: '2rem 0',
});

const GoalHeader = styled.h3(
    {
        color: color.blueLagoon,
    },
    font.heavy(font.size.mediumExtended),
);

const GoalIcon = styled.img({
    display: 'inline-block',
    marginRight: '0.5rem',
});

const GoalName = styled.span({
    color: color.chathamsBlue,
});

const QuestionWrapper = styled.div({
    borderRadius: 5,
    padding: '1.5rem 1rem',
    backgroundColor: hexToRgba(color.scooter, 0.1),
});

interface Props extends WithTranslation {
    programId: ProgramEnum;
    surveyId: GenericProgramSurvey;
    goalAnswers: GenericSurveyAnswer[];
    question: GenericSurveyQuestion | undefined;
}

export const GoalImportance = withTranslation()(
    ({ programId, surveyId, goalAnswers, question, t }: Props) => {
        const goalNameAnswer = goalAnswers.find(answer => answer.renderId === 'goalName');
        const goalName = goalNameAnswer && goalNameAnswer.data.content;

        return (
            <GoalImportanceWrapper>
                {goalName && (
                    <GoalHeader>
                        <GoalIcon src={goalIcon} />
                        {`${t('common.goal')}: `}
                        <GoalName>{goalName}</GoalName>
                    </GoalHeader>
                )}
                <QuestionWrapper>
                    <SurveyQuestionSwitch
                        programId={programId}
                        surveyId={surveyId}
                        question={question}
                    />
                </QuestionWrapper>
            </GoalImportanceWrapper>
        );
    },
);
